import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../services/authentication.service';
import { RequestStateService } from './../services/request-state.service';
import { BearerService } from '../services/bearer-service.service';
// chequea 401 token expired y sesiones antiguas y cualquier error que nos interese controlar y enviar a login
// o a una pantalla de lock screen, indicando.... Hola Usuario, su sesión ha expirado vuelve a introducir tu clave
// se refresca el token ( tecnicamente hace un nuevo login) y puede volver a seguir trabajando.

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {

  lastRequest: Date;
  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private toastr: ToastrService,
    private activatedRoute: ActivatedRoute,
    private requestStateService: RequestStateService,
    private bearerService: BearerService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(tap((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        // do stuff with response if you want
      }
    }, (err: any) => {
      if (err instanceof HttpErrorResponse) {
        if (err.status === 401) {
          this.authService.logout(true);
          const bearer = this.bearerService.getBearer();
          if (bearer.startsWith('Docout')) {
            this.toastr.clear();
            this.toastr.warning('Su sesión ha expirado.', 'Sesión expirada');
            this.activatedRoute.paramMap.subscribe((params: ParamMap) => {
              this.requestStateService.setLastUnauthorizedUrl(this.router.routerState.snapshot.url);
              this.router.navigate(['/login']);
            });
          } else {
            this.router.navigate(['error'], { queryParams: { message: 'Su usuario no está autorizado en single sign on' } });
          }
        } else {
          if (err.status === 403) {
            this.toastr.clear();
            this.toastr.warning('No puede realizar esta operación', 'Operación prohibida');
          }
        }
      }
    }));
  }

}
